var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailOpenIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 14.0006L13.4768 19.4836L13.4796 19.4858C14.3838 20.1489 14.8362 20.4807 15.3317 20.6088C15.7696 20.7221 16.23 20.7221 16.668 20.6088C17.1639 20.4806 17.6176 20.1478 18.5234 19.4836L26.0003 14.0006M26.4002 12.0532L18.9349 6.07608C18.008 5.33392 17.5441 4.96297 17.0286 4.81566C16.5738 4.68568 16.0923 4.6788 15.634 4.79613C15.1147 4.9291 14.6412 5.28696 13.694 6.00316L5.69271 12.0535C5.07173 12.5231 4.76164 12.758 4.53776 13.0548C4.33947 13.3176 4.1917 13.6149 4.10166 13.9315C4 14.2891 4 14.6784 4 15.4569V23.7341C4 25.2276 4 25.9747 4.29065 26.5451C4.54631 27.0469 4.95396 27.4545 5.45573 27.7102C6.0256 28.0006 6.77199 28.0006 8.26255 28.0006H23.7375C25.228 28.0006 25.9733 28.0006 26.5432 27.7102C27.045 27.4545 27.454 27.0466 27.7096 26.5448C28 25.9749 28 25.2292 28 23.7387V15.3693C28 14.6264 28 14.2527 27.905 13.9075C27.8202 13.5996 27.6794 13.3095 27.492 13.0509C27.2806 12.759 26.9878 12.5237 26.4002 12.0532Z",
    stroke: "#282828",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailOpenIcon);
export default __webpack_public_path__ + "static/media/MailOpenIcon.5f0b608183d0676402e2294ff49e82cb.svg";
export { ForwardRef as ReactComponent };